import React, { Component, Fragment } from 'react';
import { array } from 'prop-types';
import classNames from 'classnames/bind';

import { concatCharacteristics } from 'utils/concatCharacteristics';
import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './TabAbout.module.scss';
const cx = classNames.bind(styles);

class TabAbout extends Component {
  static propTypes = {
    data: array.isRequired,
  };

  componentDidMount() {
    // Remove min-height style to prevent jumping tabs on click.
    document.getElementById('product-tabs') &&
      document.getElementById('product-tabs').removeAttribute('style');
  }

  render() {
    const {
      props: { data },
    } = this;
    const attributes = data.length ? concatCharacteristics(data) : [];

    return (
      <div className={cx('tab-content')}>
        <table className={cx('table')}>
          <tbody>
            {attributes.map((item) => (
              <tr className={cx('row')} key={item.attrValueId}>
                {item.attrValue && item.attrValue.length && (
                  <Fragment>
                    <td className={cx('cell')}>{item.attrName}</td>
                    <td className={cx('cell')}>
                      {item.attrValue}
                      &nbsp;
                      {item.attrUnit || ''}
                    </td>
                  </Fragment>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withErrorBoundary(TabAbout);



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabAbout/TabAbout.js